export enum RegisteredUserStatusEnum {
    'Declined' = 0,
    'Approved' = 1,
    'Awaiting' = 2,
    'NotRegistered' = 3,
    'RegistrationStarted' = 4
}

export const RegisteredUserStatusList = (): any[] => {
    const types = [] as any;
    for (var enumMember in RegisteredUserStatusEnum) {
        var isValueProperty = parseInt(enumMember, 10) >= 0
        if (isValueProperty) {
            types.push({
                value: enumMember,
                label: RegisteredUserStatusEnum[enumMember]
            });
        }
    }
    return types;
}